import { FormikProps } from "formik";
import { extendedApiSlice, AppDispatch } from "../../../store";

import {
  generateCoordinatesFromPostalCode,
  generatePostalCode,
} from "../../../../../MPP-Common-SPA/utils/generator";

export interface HandlerDependencies {
  form: FormikProps<any>;
  dispatch: AppDispatch;
}

export const createEvacuationLocationHandlers = ({
  form,
  dispatch,
}: HandlerDependencies) => {
  async function handleEvacuationLocationChange(
    value: boolean,
    coordinatesData: any
  ) {
    if (value) {
      setEligibleCoordinates(coordinatesData);
    } else {
      await generateIneligibleCoordinates();
    }

    form.setFieldValue("EvacuationLocation.eligibleEvacuationLocation", value);
    setTimeout(() => form.validateForm());
  }

  function setEligibleCoordinates(coordinatesData: any) {
    form.setFieldValue("EvacuationLocation.mapLat", coordinatesData[1]);
    form.setFieldValue("EvacuationLocation.mapLng", coordinatesData[0]);
  }

  async function generateIneligibleCoordinates() {
    const defaultCoords = { lat: 0, lng: 0 };
    const maxRetries = 10;
    let attempts = 0;

    while (attempts < maxRetries) {
      // try {
      //   // const generatedPostalCode = generatePostalCode();
      //   // // const coordinatesData = await generateCoordinatesFromPostalCode(
      //   // //   generatedPostalCode
      //   // // );

      //   // const coordinates =
      //   //   extractCoordinates(coordinatesData) || defaultCoords;
      //   // const isEligible = await validateAndSetCoordinates(coordinates);

      //   if (!isEligible) {
      //     return;
      //   }

      //   attempts++;
      //   console.log(
      //     `Attempt ${attempts}: Generated coordinates are valid, retrying...`
      //   );
      // } catch (error) {
      //   console.error("Error generating coordinates from postal code:", error);
      //   setCoordinates(defaultCoords);
      //   return;
      // }
    }

    console.warn(
      `Could not generate ineligible coordinates after ${maxRetries} attempts. Using default.`
    );
    setCoordinates(defaultCoords);
  }

  function extractCoordinates(coordinatesData: any) {
    const hasCoordinates =
      coordinatesData &&
      "lat" in coordinatesData &&
      "lng" in coordinatesData &&
      coordinatesData.lat &&
      coordinatesData.lng;
    return hasCoordinates
      ? { lat: coordinatesData.lat, lng: coordinatesData.lng }
      : null;
  }

  async function validateAndSetCoordinates(coordinates: {
    lat: number;
    lng: number;
  }): Promise<boolean> {
    try {
      const coordinatesRequest = {
        mapLat: coordinates.lat,
        mapLng: coordinates.lng,
      };

      const isInEvacuationZone = await dispatch(
        extendedApiSlice.endpoints.IsPointInEvacuationZone.initiate(
          coordinatesRequest
        )
      ).unwrap();

      const isEligible = isInEvacuationZone;

      console.log(
        `Generated coordinates are ${
          isEligible ? "VALID" : "INVALID"
        } for evacuation zone`
      );

      if (!isEligible) {
        setCoordinates(coordinates);
        form.setFieldValue(
          "EvacuationLocation.eligibleEvacuationLocation",
          false
        );
      }

      return isEligible;
    } catch (validationError) {
      console.error("Error validating coordinates:", validationError);
      setCoordinates(coordinates);
      return true;
    }
  }

  function setCoordinates(coordinates: { lat: number; lng: number }) {
    form.setFieldValue("EvacuationLocation.mapLat", coordinates.lat);
    form.setFieldValue("EvacuationLocation.mapLng", coordinates.lng);
  }

  return {
    handleEvacuationLocationChange,
  };
};
